import { gql } from '@apollo/client';
import { query } from '../../../../Services/Gateway/Apollo';
import { getCompositeSubmissionId } from '../../../../Helpers/originId';

export const IS_SELECTED_SUBSCRIPTION_MATCHING = gql`
  query IsSelectedSubscriptionMatching(
    $submissionId: String!
    $answers: [AnswerInput!]!
  ) {
    isSelectedSubscriptionMatching(
      submissionId: $submissionId
      answers: $answers
    ) {
      isMatching
    }
  }
`;

/** Whether the journey's subscription still matches the lead, given the answers. */
const isSelectedSubscriptionMatchingQuery = async ({
  submissionId,
  token,
  answers,
}) => {
  const response = await query({
    query: IS_SELECTED_SUBSCRIPTION_MATCHING,
    variables: {
      submissionId: getCompositeSubmissionId(submissionId),
      answers,
    },
    fetchPolicy: 'no-cache',
    context: { headers: { Authorization: `Bearer ${token}` } },
  });

  const isMatching = response?.data?.isSelectedSubscriptionMatching?.isMatching;
  if (typeof isMatching !== 'boolean') {
    throw new Error(
      `isSelectedSubscriptionMatching returned no boolean isMatching: ${JSON.stringify(
        response?.data
      )}`
    );
  }

  return isMatching;
};

export default isSelectedSubscriptionMatchingQuery;
